<router-outlet></router-outlet>



<p-toast key="home-bc" position="bottom-center" [preventOpenDuplicates]="true"></p-toast>
